import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  Text
} from "@modernatx/ui-kit-react";
import React from "react";

import { useFeatureFlag } from "@/context/FeatureFlagContext";
import { InvoiceItem } from "@/types/Invoice";
import { formatCurrency } from "@/utils/InvoicePay";

const ItemizedInvoiceItemsTable: React.FC<{ items: InvoiceItem[] }> = ({
  items
}) => {
  const onlineDiscountEnabled = useFeatureFlag("ONLINE_DISCOUNT");

  const priceHeader = onlineDiscountEnabled
    ? "Price per dose*"
    : "Contract price";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "spacing-2" }}>
      <Table variant="unshaded">
        <TableHeaderRow>
          <TableRow>
            <TableHeaderCell>
              <Text weight="bold">NDC</Text>
            </TableHeaderCell>
            <TableHeaderCell grow={4}>
              <Text weight="bold">Items</Text>
            </TableHeaderCell>
            <TableHeaderCell>
              <Text weight="bold">{priceHeader}</Text>
            </TableHeaderCell>
            <TableHeaderCell>
              <Text weight="bold">Doses</Text>
            </TableHeaderCell>
            <TableHeaderCell>
              <Text weight="bold">Subtotal</Text>
            </TableHeaderCell>
          </TableRow>
        </TableHeaderRow>
        <TableBody>
          {items.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.ndcNumber || "--"}</TableCell>
              <TableCell>{item.itemDescription || "--"}</TableCell>
              <TableCell>{formatCurrency(item.contractPrice)}</TableCell>
              <TableCell>{item.quantity || "--"}</TableCell>
              <TableCell>{formatCurrency(item.subtotal)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {onlineDiscountEnabled && (
        <Text sx={{ color: "text-incidental" }} variant="body-2-regular">
          *Online discount is included in price if applicable
        </Text>
      )}
    </Box>
  );
};

export default ItemizedInvoiceItemsTable;
